import { render } from "./Services.vue?vue&type=template&id=37fc7b84&ts=true"
import script from "./Services.vue?vue&type=script&lang=ts"
export * from "./Services.vue?vue&type=script&lang=ts"

import "./Services.vue?vue&type=style&index=0&id=37fc7b84&lang=scss"

import exportComponent from "C:\\Users\\nahue\\OneDrive\\Escritorio\\Proyectos\\SWMOTORES\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__